export const formatGraphQlEnumValue = (enumValue: string) =>
  enumValue.slice(enumValue.startsWith('_') ? 1 : 0);
